import React, { useEffect, useState } from "react";
import FormRender from "../../components/FormRender";
import { PRODUCT_VIDEO_FORM_SETTING, PRODUCT_VIDEO_FORM_SETTING_META } from "../../helper";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";

const AddProductVideo = () => {
    const axiosInstance = useAxiosInstance();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        thumbnail_img: "",
        video_src: "",
        type: "features_videos",
        is_sidebar_video: false,
        meta: {
            time: "",
            order: "",
            feature_type: "",
            home: false,
            report_type: "",
            email_video_desc: "",
            feature_card_key: "",
        },
    });
    const [saving, setSaving] = useState(false);

    const setMetaFormData = (metaUpdate) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            meta: {
                ...prevFormData.meta,
                ...metaUpdate,
            },
        }));
    };

    function handleSave() {
        setSaving(true);
        const payload = {
            ...formData,
            is_sidebar_video: Boolean(formData.is_sidebar_video),
            meta: formData.meta,
        };
         const _formData = new FormData();
        _formData.append('payload', JSON.stringify(payload));
        _formData.append('thumbnail_img', payload.thumbnail_img);
       
        axiosInstance.post('/assets/create_a_product_video/', _formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
        }).then(res=>{
            if(res.status===200){
                toast.success('Successfully created!')
            }else{
                toast.error('Failed!')
            }
            setSaving(false);
        }).catch(err=>{
            toast.error('Failed!');
            setSaving(false);})
        console.log("This payload", payload);
    }

    const [isLoading, setIsLoading] = useState(false);

    return (
        <div>
            <div className="p-6">
                <div className="text-2xl font-semibold items-center flex justify-between">
                    Add Product Video
                </div>
                <div className="mt-4 p-4 border rounded-lg bg-white  flex flex-col gap-y-4">
                    {isLoading ? (
                        <>loading...</>
                    ) : (
                        <>
                            <FormRender
                                formData={formData}
                                formSettings={PRODUCT_VIDEO_FORM_SETTING}
                                setFormData={setFormData}
                                select_options={{
                                    type: PRODUCT_VIDEO_FORM_SETTING.find(
                                        (it) => it.saveKey === "type"
                                    )?.options,
                                }}
                            />
                            <div className="text-2xl font-semibold items-center flex justify-between">
                                Meta
                            </div>
                            <FormRender
                                formData={formData.meta}
                                formSettings={PRODUCT_VIDEO_FORM_SETTING_META}
                                setFormData={setMetaFormData}
                            />
                        </>
                    )}
                    <button
                        disabled={saving}
                        onClick={() => handleSave()}
                        className="text-sm px-3 py-2 self-end bg-black rounded-lg text-white disabled:bg-slate-100"
                    >
                        {saving ? "Loading..." : "Add"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddProductVideo;